import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'vds-content-title',
  styleUrl: 'vds-content-title.scss',
  shadow: true,
})
export class VdsContentTitle {

  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
  @Prop() headline = '';

  /**
   * Subline for the Content Module
   * Mandatory: no
   * Max Chars: 150
   */
  @Prop() subline = '';

  render() {
    const { headline, subline } = this;

    return (
      <Host>
        <h1 class="font-heavy text-h1-mobile sm:text-h1-tablet lg:text-h1-desktop text-grey uppercase break-words" innerHTML={headline}></h1>
        <h2 class="font-regular text-s1-mobile sm:text-s1-tablet lg:text-s1-desktop text-berry uppercase mt-2 break-words" innerHTML={subline}></h2>
      </Host>
    );
  }

}
